import React from "react";
import { Grid } from "antd";
import clsx from "clsx";
import styles from "layouts/mobileInnerWrapper/mobileInnerWrapper.module.scss";

type ComponentProps = {
  children: React.ReactNode;
  isCentered?: boolean;
};

const { useBreakpoint } = Grid;

const Component: React.FC<ComponentProps> = ({
  children,
  isCentered = false,
}) => {
  const screens = useBreakpoint();

  const isMobile = !screens.lg;

  if (!isMobile) return <>{children}</>;

  return (
    <div className={clsx(styles.wrapper, !!isCentered && styles.isCentered)}>
      {children}
    </div>
  );
};

export default Component;
